import * as React from 'react';
import Icon from './Icon';

const Heart: React.FunctionComponent = () => (
  <Icon height={18} width={14} viewBox={'0 0 37.570832 34.660418'} color={'#6f471c'} style={{ marginRight: 10}}>
    <g
      transform="translate(0,-262.33957)"
      id="layer1">
      <path
        id="path826"
        d="M 16.497833,295.57252 C 7.3115875,289.13889 2.7587968,283.98925 0.63306991,277.62796 c -0.61396327,-1.8373 -0.69136705,-2.43023 -0.60247544,-4.61522 0.08705316,-2.13997 0.22431095,-2.76868 0.93738166,-4.29353 1.54524327,-3.3044 4.61807077,-5.69081 8.04883967,-6.25087 3.3564862,-0.54794 7.6727722,0.94316 9.3287992,3.22271 0.328268,0.45187 0.415997,0.41599 1.402858,-0.57385 2.056522,-2.06275 5.67359,-3.15975 8.758124,-2.65621 3.439842,0.56154 6.559247,2.9739 8.092446,6.25822 0.70197,1.5037 0.850855,2.17238 0.940701,4.22487 0.09093,2.07831 0.006,2.75988 -0.573706,4.61522 -1.627835,5.20764 -5.055732,9.58611 -11.608509,14.82758 -2.163629,1.73066 -6.325287,4.62781 -6.626485,4.61306 -0.115355,-0.006 -1.120302,-0.64799 -2.233211,-1.42742 z"/>
    </g>
  </Icon>
)

export default Heart;
